<template>
  <div   class="page-index">
    <!--<h4 style="padding-top: 0.5rem;text-align: center" v-if="description && description !== 'group'">{{description}}</h4>-->
    <div class="nav-div" v-if="showFilterBarFlag">
      <nav class="bar bar-nav merbar" style="padding-left: 0rem;padding-right: 0rem">
        <div class="list-block media-list" style="margin-top: 0rem;margin-bottom: 0rem;">
          <ul>
            <li class="item-content">
              <div class="item-inner">
                <div  style="float: left">为您找到<span style="color: #0a8ddf;">{{queryTotal.total}}</span>条结果</div>
                <div  style="color: #0a8ddf;float: right" v-if="!showFilterBarForKit"><a class="pull-right open-panel" @click="openshaxuan()">筛选</a></div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div style="height: 2.2rem;" v-if="Number(this.$route.query.id) === 5 || Number(this.$route.query.id) === 8 || Number(this.$route.query.id) === 14 || Number(this.$route.query.id) === 7 || Number(this.$route.query.id) === 9 || this.$route.name === 'searchresults'"></div>
    <div>
      <div class="list-block media-list" style="margin-top: 0rem;">
        <ul style="border-top: 0px solid #e7e7e7" class="list-container">
          <li v-for="pro in merchListWithoutCustomized10">
            <div style="padding-left: .5rem" v-if="description === 'group'">
              <div class="item-inner" style="padding-bottom: 0rem" @click="clickMerchandise(pro)">
                <div class="item-title-row">
                  <span v-if="pro.bpromotions && pro.bpromotions.length > 0 &&  pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== ''">
                       <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.bpromotions[0].name}}
                       </span>
                  </span>
                  <span v-if="pro.promotions && pro.promotions.length > 0  &&  pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].type !== 0 && pro.promotions[0].description !== '' ">
                       <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.promotions[0].name}}
                         <!--<span v-if="pro.promotions[0].type === 6">-->
                            <!--<span v-if="secInfo && secInfo.seckillType === 1"> | {{secPromotionRatio}}折</span>-->
                         <!--</span>-->
                       </span>
                  </span>
                  <!--促销开始小图标-->
                  <div class="item-after" v-if="pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].type === 6">
                      <img src="/emktResources/resocurces/img/promotion/miaosha_mobile.png" alt="秒杀进行/预告" height="30px">
                  </div>
                  <div class="item-after" v-if="pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type === '6'">
                      <img src="/emktResources/resocurces/img/promotion/miaosha_mobile.png" alt="秒杀进行/预告" height="30px">
                  </div>
                </div>
                <div class="item-title-row">
                  <div class="item-title"><span v-for="title in pro._titleList" style="margin-right: .3rem"> <span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span></div>
                </div>
                <div class="item-subtitle" style="font-size: xx-small">
                  <label class="label-checkbox checkbox-el " v-for="abstract in pro._abstractList">
                    <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;"><span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></div></div>
                  </label>
                    <label class="label-checkbox checkbox-el " v-for="subTitle in pro._subTitleList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;" v-if="subTitle.valueText && subTitle.valueText.length > 15">{{subTitle.valueText.substring(0,15)}}...</div>
                        <div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;" v-else>{{subTitle.valueText}}</div></div>
                    </label>
                  </div>
                <div class="item-text" style="height: 2rem"><div>
                  <div style="float:left;">
                    <span style="color: #1D66E1;font-size: .7rem" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1">¥{{pro.priceMax}}</span>
                    <span style="color: #1D66E1;font-size: .7rem" v-else><span v-if="pro.categoryId === 20">¥{{Math.floor(pro.priceMin)}}起</span>
                        <span v-else>¥{{pro.priceMin}}</span></span>
                    <span style="margin-left: .3rem"><button class="button workdays" >
                      <span v-if="pro.categoryId === 20">周期{{pro.cycle}}工作日起</span>
                    <span v-else>周期{{pro.cycle}}工作日</span>
                    </button></span></div>
                  <div style="float: right;font-size: .5rem" v-if="pro.totalSales === pro.salesLimit && pro.salesLimit !== -1">
                    <span class="sub-span" style="background-color: #FF9400">缺货</span>
                    <span  v-if="pro.selfOperated === 0" class="sub-span">代购</span>
                  </div>
                  <div style="float: right;font-size: .5rem" v-else>
                    <span class="sub-span" v-if="pro.stockOrCustomized === 0">现货</span>
                    <span class="sub-span" v-if="pro.stockOrCustomized === 1" style="background-color: #ff0000">定制</span>
                    <span  v-if="pro.selfOperated === 0" class="sub-span">代购</span>
                    <!--<span class="sub-span">减券</span>-->
                  </div>
                  <div v-if="showInventoryStockRemark(pro)" style="float: left;font-size: .5rem">
                    <span style="color: red">{{inventoryStockRemark}}</span>
                  </div>
                </div>
                <div>
                  <span style="margin-left: 3px;font-size: small; color: #4479B4" v-if="pro._specificatList && pro._specificatList.length > 0" v-for="specificat in pro._specificatList">{{specificat.label}}: {{specificat.valueText}}</span>
                </div>
                <div style="font-size: .4rem;color: rgb(29, 102, 225)" v-if="pro._attributes.Product_Master && pro._attributes.Product_Master.value !=='Customize'">{{pro._attributes.Product_Master.value}}</div>
                </div>
              </div>
            </div>
            <div style="padding-left: .5rem" v-else>
              <div v-if="!pro.composite">
                <div class="item-inner" style="padding-bottom: 0rem" @click="clickMerchandise(pro)">
                  <div class="item-title-row" v-if="filteredShowPromotions(pro) && filteredShowPromotions(pro).length > 0">
                    <span>
                      <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{filteredShowPromotions(pro)[0].name}}</span>
                    </span>
                    <!--促销开始小图标-->
                    <div class="item-after" v-if="filteredShowPromotions(pro)[0].type === 6">
                      <img src="/emktResources/resocurces/img/promotion/miaosha_mobile.png" alt="秒杀进行/预告" height="30px" v-if="secFlag!==2">
                    </div>

                  </div>
                  <div class="item-title-row">

                    <div class="item-title"><span v-for="title in pro._titleList" style="margin-right: .3rem"> <span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span></div>

                  </div>
                  <div class="item-subtitle" style="font-size: xx-small">
                    <label class="label-checkbox checkbox-el " v-for="abstract in pro._abstractList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;"><span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></div></div>
                    </label>
                    <label class="label-checkbox checkbox-el " v-for="subTitle in pro._subTitleList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;" v-if="subTitle.valueText && subTitle.valueText.length > 15">{{subTitle.valueText.substring(0,15)}}...</div>
                        <div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;" v-else>{{subTitle.valueText}}</div></div>
                    </label>
                  </div>
                  <div class="item-text"  style="height: 2rem"><div >
                    <div style="float:left;">  <span style="color: #1D66E1;font-size: .7rem" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1">¥{{pro.priceMax}}</span>
                      <span style="color: #1D66E1;font-size: .7rem" v-else><span v-if="pro.categoryId === 20">¥{{Math.floor(pro.priceMin)}}起</span>
                        <span v-else>¥{{pro.priceMin}}</span></span> <span style="margin-left: .3rem"><button class="button workdays" >  <span v-if="pro.categoryId === 20">周期{{pro.cycle}}工作日起</span>
                    <span v-else>周期{{pro.cycle}}工作日</span></button></span></div>
                    <div style="float: right;font-size: .5rem" v-if="pro.totalSales === pro.salesLimit && pro.salesLimit !== -1">
                      <span class="sub-span" style="background-color: #FF9400">缺货</span>
                      <span  v-if="pro.selfOperated === 0" class="sub-span">代购</span>
                    </div>
                    <div style="float: right;font-size: .5rem" v-else>
                      <span class="sub-span" v-if="pro.stockOrCustomized === 0">现货</span>
                      <span class="sub-span" v-if="pro.stockOrCustomized === 1" style="background-color: #ff0000">定制</span>
                      <span  v-if="pro.selfOperated === 0" class="sub-span">代购</span>
                      <!--<span class="sub-span">减券</span>-->
                    </div>
                    <div v-if="showInventoryStockRemark(pro)" style="float: left;font-size: .5rem">
                      <span style="color: red">{{inventoryStockRemark}}</span>
                    </div>
                  </div></div>
                  <div style="font-size: .4rem;margin-bottom: .5rem;color: rgb(29, 102, 225)" v-if="pro._attributes.Product_Master  && pro._attributes.Product_Master.value !=='Customize'">{{pro._attributes.Product_Master.value}}</div>
                </div>
              </div>
              <div v-else>
                <div class="item-inner" style="padding-bottom: 0rem"  @click="setdatas(pro)">
                  <div class="item-title-row" v-if="filteredShowPromotions(pro) && filteredShowPromotions(pro).length > 0">
                    <span>
                      <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{filteredShowPromotions(pro)[0].name}}</span>
                    </span>
                    <!--促销开始小图标-->
                    <div class="item-after" v-if="filteredShowPromotions(pro)[0].type === 6">
                      <img src="/emktResources/resocurces/img/promotion/miaosha_mobile.png" alt="秒杀进行/预告" height="30px" v-if="secFlag!==2">
                    </div>

                  </div>
                  <div class="item-title-row">
                    <div class="item-title"><span v-for="title in pro._titleList" style="margin-right: .3rem"> <span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span></div>
                  </div>
                  <div class="item-subtitle" style="font-size: xx-small">
                    <label class="label-checkbox checkbox-el " v-for="abstract in pro._abstractList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;"><span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></div></div>
                    </label>
                    <label class="label-checkbox checkbox-el " v-for="subTitle in pro._subTitleList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;" v-if="subTitle.valueText && subTitle.valueText.length > 15">{{subTitle.valueText.substring(0,15)}}...</div>
                        <div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem;" v-else>{{subTitle.valueText}}</div>
                      </div>
                    </label>
                  </div>
                  <div class="item-text" style="height: 2rem"><div >
                    <div style="float:left;">
                      <span  v-if="pro.priceMin !== pro.priceMax">
                         ¥{{pro.priceMin}} ~ ¥{{pro.priceMax}}
                      </span>
                      <span  v-else>

                        <span style="color: #1D66E1;font-size: .7rem" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1">¥{{pro.priceMax}}</span>
                        <span style="color: #1D66E1;font-size: .7rem" v-else>
                        <span v-if="pro.categoryId === 20">¥{{Math.floor(pro.priceMin)}}起</span>
                        <span v-else>¥{{pro.priceMin}}</span>
                        </span>
                      </span>
                      <span style="margin-left: .3rem"><button class="button workdays" >  <span v-if="pro.categoryId === 20">周期{{pro.cycle}}工作日起</span>
                    <span v-else>周期{{pro.cycle}}工作日</span></button></span></div>
                    <div style="float: right;font-size: .5rem" v-if="pro.totalSales === pro.salesLimit && pro.salesLimit !== -1">
                      <span class="sub-span" style="background-color: #FF9400">缺货</span>
                      <!--<span class="sub-span">减券</span>-->
                    </div>
                    <div style="float: right;font-size: .5rem" v-else>
                          <span class="sub-span" v-if="pro.stockOrCustomized === 0">现货</span>
                          <span class="sub-span" v-if="pro.stockOrCustomized === 1" style="background-color: #ff0000">定制</span>
                      <!--<span class="sub-span">减券</span>-->
                    </div>
                    <div v-if="showInventoryStockRemark(pro)" style="float: left;font-size: .5rem">
                      <span style="color: red">{{inventoryStockRemark}}</span>
                    </div>
                  </div>
                  </div>
                  <div style="font-size: .4rem;color: rgb(29, 102, 225)" v-if="pro._attributes.Product_Master  && pro._attributes.Product_Master.value !=='Customize'">{{pro._attributes.Product_Master.value}}</div>
                </div>

              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery'
  import emkt from '../../../emkt'
  import {mapState, mapMutations, mapGetters} from 'vuex'
  export default {
    // 在 props 中声明获取父组件的数据通过 message 传过来
    props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        total: 0,
        inventoryStockRemark: '下单7天未确认订单，订单会被自动取消'
      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE'
      ]),
      addCartListForRecom (pro) {
        this.ADD_CART_LIST(pro)
        $.toast('加入购物车成功！')
      },
      setdatas (pro) {
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': emkt.customerBehaviourType.clickMer}
        }
        var _self = this
        _self.MERCHDISEGROUP_UPDATE(pro.compositions)
        this.$router.push({path: '/promotion/Compositions'})
      },
      openshaxuan () {
        $.openPanel('#panel-right-demo')
      },
      getbpromotions (merchdise) {
        if (merchdise.bpromotions) {
          var bpromotions = merchdise.bpromotions
          var r = []
          var t = []
          for (var m = 0; m < bpromotions.length; m++) {
            if (t.indexOf(bpromotions[m].type) === -1) {
              r.push(bpromotions[m])
              t.push(bpromotions[m].type)
              // console.log(m + ' ' + bpromotions[m].type)
            }
          }
          return r
        }
      },
      clickMerchandise (pro) {
        var id = ''
        var cid = 0
        if (pro.categoryId === 20 && pro.findId) {
          id = pro.findId
        } else if (pro.categoryId === 20 && !pro.findId) {
          cid = 20
          id = pro.merchandiseId
        } else {
          id = pro.merchandiseId
        }
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': id, 'type': emkt.customerBehaviourType.clickMer}
        }
        if (this.proo) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {pro: this.proo}})
        } else if (this.channel) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {channel: this.channel}})
        } else {
          if (cid === 20) {
            this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId, cid: 20}})
          } else {
            this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}})
          }
        }
      },
      filteredShowPromotions (merchandise) {
        if (merchandise.promotions && merchandise.promotions.length > 0) {
          return merchandise.promotions.filter(pro => pro.requiredCustomers === 0 && pro.description && pro.type !== 0)
        }
        if (merchandise.bpromotions && merchandise.bpromotions.length > 0) {
          return merchandise.bpromotions.filter(pro => pro.requiredCustomers === 0 && pro.description && pro.type !== 0)
        }
        return []
      },
      showInventoryStockRemark (merchandise) {
        return merchandise && merchandise.merchandiseLabel && merchandise.merchandiseLabel.indexOf('极速现货') !== -1
      }
    },
    computed: {
      ...mapState([
        'queryTotal', 'sessionInfo', 'secInfo'
      ]),
      ...mapGetters([
        'secFlag'
      ]),
      merchs: function () {
        var newmerchList = []
        if (!this.merchList) {
          return newmerchList
        }
        newmerchList = this.merchList
//        for (var i = 0; i < newmerchList.length; i++) {
//          var tags = []
//          var merchandiseMeta = emkt.getEmktMetaData()
//          var tagsmap = merchandiseMeta.tagsMap
//          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
//            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
//          }
//          newmerchList.tags = tags
//          var bpromotions = newmerchList[i].bpromotions
//          var r = []
//          var t = []
//          for (var m = 0; m < bpromotions.length; m++) {
//            if (t.indexOf(bpromotions[m].type) === -1) {
//              r.push(bpromotions[m])
//              t.push(bpromotions[m].type)
//              console.log(m + ' ' + bpromotions[m].type)
//            }
//          }
//          newmerchList[i].bpromotions = r
//        }
        this.total = newmerchList.length
        return newmerchList
      },
      showFilterBarFlag () {
        let flag = true
        let src = this.$route.name
        if (src === 'home') {
          flag = false
        }
        if (!this.showFilterBar) {
          flag = false
        }
        return flag
      },
      secPromotionRatio () {
        let ratio = String(100 - this.secInfo.seckilltRatio * 100)
        ratio = (ratio[1] === '0') ? ratio[0] : ratio
        return ratio
      },
      merchListWithoutCustomized10 () {
        if (this.merchList && this.merchList.length > 0) {
          return this.merchList.filter(product => product.categoryId !== 10)
        }
        return []
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



  .checkbox-el {
    display: inline-block;
    text-align: left;
  }


  /*搜索内容区*/
  .item-inner {
    display: block;
  }
  .item-title {
    font-size: 0.6rem;
  }
  item-text {
    margin-top: 0.3rem;
  }
  .sub-span {
    font-size: 0.5rem;
    color: white;
    background-color: #00469A;padding: 0.1rem;border-radius:.25rem;
  }

  .workdays {
    display: inherit;font-size: .5rem;line-height: 0px;height: 0.85rem;border-radius:.45rem;border:1px solid #1D66E1;color:#1D66E1
  }
  .radiuscolor {
    background-color: #E6E6E6;border-radius:.25rem;
  }
</style>



// WEBPACK FOOTER //
// NewMerchandiseListA.vue?e1bf6e74